export enum Actions {
  insert = 'tree.insert',
  load = 'tree.load',
  remove = 'tree.remove',
  select = 'tree.select',
  update = 'tree.update'
}
